import React from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router';

import axios from './../../../constants/axios';

class PurchaseUnAuthorized extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         unAuthorized: []
      };
   }

   componentDidMount() {
      axios.get('inventoryPurchases/getUnAuthorized')
         .then((res) => {
            this.setState({
               unAuthorized: res.data
            });
         });
   }

   render() {
      const { unAuthorized } = this.state;
      return (
         <Table >
            <thead >
            <tr >
               <th >#inv Id</th >
               <th >Contact Name</th >
               <th >Billed</th >
               <th >Paid Amount</th >
               <th >Due</th >
               <th >Inv Created</th >
               <th >##</th >
            </tr >
            </thead >
            <tbody >
            {unAuthorized.map((bill) => (
               <tr key={bill.id} >
                  <td >{bill.id}</td >
                  <td >{bill.contact_name}</td >
                  <td >{bill.total_amount}</td >
                  <td >{bill.paid_amount}</td >
                  <td >{bill.due}</td >
                  <td >{bill.created_at}</td >
                  <td >
                     <Link to={`/purchase/purchaseInvoiceDetail/${bill.id}`} >Details</Link >
                  </td >
               </tr >
            ))}
            </tbody >
         </Table >
      );
   }
}


export default PurchaseUnAuthorized;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Purchase/PurchaseUnAuthorized.js
 **/